import * as React from 'react';

interface Question {
  label: string;
  response: string;
}

interface Feedback {
  template: Question[];
}

export default class AppointmentPDFComponent extends React.Component<{
  feedback: Feedback;
}> {
  render() {
    const questions: Question[] = this.props.feedback.template;

    return questions.map((question: Question, index: number) => (
        <div className="row" key={index}>
          <div className="col-xs-4" style={{ textAlign: 'right' }}>
            <label style={{ wordBreak: 'break-word' }}>{question.label}</label>
          </div>
          <div className="col-xs-7">{question.response}</div>
        </div>
      ));
  }
}
